// extracted by mini-css-extract-plugin
module.exports = {"simpleLink":"SimpleLink_simpleLink__3DhtL","noUnderline":"SimpleLink_noUnderline__2Lyau"};